import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { errorToast, successToast } from "../Toast";
import { Field, Form, Formik, ErrorMessage } from "formik";
import {
  createProductApi,
  getParentProductNameListApi,
} from "../../services/_product";

const createProductInitialValues = {
  name: "",
  parent_product_id: "",
  variety: "",
  description: "",
  hsn_no: "",
  status: "",
};
interface AddProductModalProps {
  addProductModalStatus: boolean;
  closeAddProductModal: () => void;
  onProductCreated: any;
}

const createProductValidationSchema = (productType: "PRODUCT" | "VARIETY") =>
  Yup.object().shape({
    name:
      productType === "PRODUCT"
        ? Yup.string().required("Product name is required")
        : Yup.string(),

    parent_product_id:
      productType === "VARIETY"
        ? Yup.string().required("product is required")
        : Yup.string(),

    variety:
      productType === "VARIETY"
        ? Yup.string().required("Variety is required")
        : Yup.string(),

    description: Yup.string(),
    hsn_no: Yup.string(),

    status: Yup.string().required("Status is required"),
  });

const AddProductModal: React.FC<AddProductModalProps> = ({
  addProductModalStatus,
  closeAddProductModal,
  onProductCreated,
}) => {
  const [submitLoader, setSubmitLoader] = useState(false);
  const [parentProducts, setParentProducts] = useState<any[]>([]);
  const [productType, setProductType] = useState<"PRODUCT" | "VARIETY">(
    "PRODUCT",
  );

  const fetchParentProducts = async () => {
    const result: any = await getParentProductNameListApi();
    if (result.isSuccess) {
      setParentProducts(result.data || []);
    }
  };
  useEffect(() => {
    if (productType === "VARIETY") {
      fetchParentProducts();
    }
  }, [productType]);

  const handleSubmit = async (values: any, { resetForm }: any) => {
    setSubmitLoader(true);

    const payload: any = {
      type: productType,
      status: values.status === "true",
      hsn_no: values.hsn_no,
      description: values.description,
    };

    if (productType === "PRODUCT") {
      payload.name = values.name;
    } else {
      const parent = parentProducts.find(
        (p) => p.id === values.parent_product_id,
      );

      payload.name = parent?.name;
      payload.parent_product_id = values.parent_product_id;
      payload.variety = values.variety;
    }

    const result: any = await createProductApi(payload);

    if (result.isSuccess) {
      setSubmitLoader(false);
      resetForm({ values: createProductInitialValues });

      successToast(result.message);

      closeAddProductModal();
      onProductCreated(result.data);
    } else {
      setSubmitLoader(false);
      errorToast(result.message);
    }
  };
  return (
    <>
      {addProductModalStatus && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div
            className="modal fade show"
            id="addProductModal"
            tabIndex={-3}
            aria-hidden={!addProductModalStatus}
            style={{ display: addProductModalStatus ? "block" : "none" }}
          >
            <div className="modal-dialog modal-lg modal-simple modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body p-4">
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={closeAddProductModal}
                  ></button>
                  <div className="text-center mb-2">
                    <h4 className="mb-2">Add Product</h4>
                  </div>
                  <div className="modal-body p-0">
                    <Formik
                      initialValues={createProductInitialValues}
                      validationSchema={createProductValidationSchema(
                        productType,
                      )}
                      onSubmit={handleSubmit}
                    >
                      {({ values, handleChange }) => (
                        <Form className="dt_adv_search">
                          <div className="row">
                            <div className="col-12 mb-3">
                              <label
                                className="form-label d-block"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Product Type :
                              </label>

                              <div
                                className="rounded px-3 py-2 d-inline-block"
                                style={{ border: "1px solid #c1c1c1" }}
                              >
                                <div className="d-flex gap-4">
                                  <div className="form-check m-0">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      id="productTypeProduct"
                                      checked={productType === "PRODUCT"}
                                      onChange={() => setProductType("PRODUCT")}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="productTypeProduct"
                                    >
                                      Product
                                    </label>
                                  </div>

                                  <div className="form-check m-0">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      id="productTypeVariety"
                                      checked={productType === "VARIETY"}
                                      onChange={() => setProductType("VARIETY")}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="productTypeVariety"
                                    >
                                      Variety
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-12">
                              <div className="row g-3">
                                {productType === "PRODUCT" && (
                                  <div className="col-12 col-sm-6 col-lg-4">
                                    <label
                                      className="form-label"
                                      style={{ fontSize: "0.9375rem" }}
                                    >
                                      Name:{" "}
                                      <span className="text-danger">*</span>
                                    </label>

                                    <Field
                                      name="name"
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Product Name"
                                    />

                                    <ErrorMessage
                                      name="name"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </div>
                                )}

                                {productType === "VARIETY" && (
                                  <div className="col-12 col-sm-6 col-lg-4">
                                    <label
                                      className="form-label"
                                      style={{ fontSize: "0.9375rem" }}
                                    >
                                      Parent Product:{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <select
                                      name="parent_product_id"
                                      className="form-select"
                                      value={values.parent_product_id}
                                      onChange={handleChange}
                                    >
                                      <option value="">
                                        Select Parent Product
                                      </option>
                                      {parentProducts.map((product) => (
                                        <option
                                          key={product.id}
                                          value={product.id}
                                        >
                                          {product.name}
                                        </option>
                                      ))}
                                    </select>
                                    <ErrorMessage
                                      name="parent_product_id"
                                      className="text-danger"
                                      component="div"
                                    />
                                  </div>
                                )}

                                {productType === "VARIETY" && (
                                  <div className="col-12 col-sm-6 col-lg-4">
                                    <label
                                      htmlFor="variety"
                                      className="form-label"
                                      style={{ fontSize: "0.9375rem" }}
                                    >
                                      Variety:{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <Field
                                      id="variety"
                                      name="variety"
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Variety"
                                      onChange={handleChange}
                                    />
                                    <ErrorMessage
                                      name="variety"
                                      className="text-danger"
                                      component="div"
                                    />
                                  </div>
                                )}

                                <div className="col-12 col-sm-6 col-lg-4">
                                  <label
                                    htmlFor="hsn_no"
                                    className="form-label"
                                    style={{ fontSize: "0.9375rem" }}
                                  >
                                    Hsn No:
                                  </label>
                                  <Field
                                    id="hsn_no"
                                    name="hsn_no"
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter hsn no"
                                    onChange={handleChange}
                                  />
                                  <ErrorMessage
                                    name="hsn_no"
                                    className="text-danger"
                                    component="div"
                                  />
                                </div>
                                <div className="col-12 col-sm-6 col-lg-4">
                                  <label
                                    htmlFor="status"
                                    className="form-label"
                                    style={{ fontSize: "0.9375rem" }}
                                  >
                                    Status:{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    id="status"
                                    name="status"
                                    className="form-select"
                                    value={values.status}
                                    onChange={handleChange}
                                  >
                                    <option value="">Select Status</option>
                                    <option value="true">Active</option>
                                    <option value="false">Inactive</option>
                                  </select>
                                  <ErrorMessage
                                    name="status"
                                    className="text-danger"
                                    component="div"
                                  />
                                </div>
                                <div className="col-12">
                                  <label
                                    htmlFor="description"
                                    className="form-label"
                                    style={{ fontSize: "0.9375rem" }}
                                  >
                                    Description:
                                  </label>
                                  <Field
                                    id="description"
                                    name="description"
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter description"
                                    onChange={handleChange}
                                    as={"textarea"}
                                    rows={2}
                                  />
                                  <ErrorMessage
                                    name="description"
                                    className="text-danger"
                                    component="div"
                                  />
                                </div>
                                <div className="col-12 text-center mt-4">
                                  <button
                                    type="submit"
                                    className="btn btn-primary me-3"
                                    disabled={submitLoader}
                                  >
                                    {submitLoader && (
                                      <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                    )}{" "}
                                    Add Product
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-label-secondary"
                                    onClick={closeAddProductModal}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AddProductModal;
